import $ from "../core/jquery-global";

export function initNavigation() {
    function setNav() {
        var $nav = $(".nav");

        if (window.scrollY <= 0) {
            $nav.removeClass("is-scrolled");
        } else if (!$nav.hasClass("is-scrolled")) {
            $nav.addClass("is-scrolled");
        }
    }

    function handleMenuScroll() {
        requestAnimationFrame(setNav);
    }

    $(window).on("scroll", handleMenuScroll);

    setNav();

    $(document).on("click", ".js_openCloseMenu", function () {
        var $nav = $(this).closest("nav");
        var $hamburger = $nav.find(".hamburger");

        if ($nav.hasClass("is_open")) {
            $nav.removeClass("is_open");
            $hamburger.removeClass("is-active");
        } else {
            $nav.addClass("is_open");
            $hamburger.addClass("is-active");
        }
    });

    $(document).on("click", "nav.is_open .menu-wrapper a", function () {
        var $nav = $(this).closest("nav");
        var $hamburger = $nav.find(".hamburger");

        $nav.removeClass("is_open");
        $hamburger.removeClass("is-active");
    });
}
